var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-container fluid mt-3"},[_c('div',{staticClass:"grid-x"},[_c('div',{staticClass:"cell"},[_c('v-card',[_c('v-card-title',[_c('h1',{staticClass:"display-2 grey--text"},[_vm._v("Dashboard")])]),_c('v-card-text',[_vm._v(" Admin Dashboard ")])],1)],1)]),_c('AdminActionButtons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }